import { render } from 'preact';
import { App } from './app';

render(<App />, document.getElementById('root')!);